// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { QuestionnaireQuestionFragmentDoc } from './QuestionnaireQuestion.fragment.generated';
import { QuestionnaireConditionFragmentDoc } from '../condition/QuestionnaireCondition.fragment.generated';
export const QuestionnaireStepContentQuestionsFragmentDoc = gql`
    fragment questionnaireStepContentQuestions on QuestionnaireStepContentQuestions {
  __typename
  questions {
    ...questionnaireQuestion
  }
  conditions {
    ...questionnaireCondition
  }
}
    ${QuestionnaireQuestionFragmentDoc}
${QuestionnaireConditionFragmentDoc}`;